import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-image-modal',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (isOpen) {
      <div
        class="fixed inset-0 z-[100] flex items-center justify-center bg-black/95 p-4 backdrop-blur-sm"
        (click)="onClose()"
      >
        <div
          class="relative max-w-6xl w-full max-h-[90vh] flex items-center justify-center"
          (click)="$event.stopPropagation()"
        >
          <img
            [src]="galleryImages[selectedImageIndex]"
            alt=""
            class="max-w-full max-h-full object-contain rounded-2xl shadow-2xl border border-white/5"
          />

          <!-- Navigation buttons -->
          @if (galleryImages.length > 1) {
            <button
              (click)="onPreviousImage()"
              class="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-black/50 hover:bg-black/70 border border-white/10 backdrop-blur-md rounded-full flex items-center justify-center text-white transition-all hover:scale-110"
            >
              <i class="fa-solid fa-chevron-left"></i>
            </button>
            <button
              (click)="onNextImage()"
              class="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-black/50 hover:bg-black/70 border border-white/10 backdrop-blur-md rounded-full flex items-center justify-center text-white transition-all hover:scale-110"
            >
              <i class="fa-solid fa-chevron-right"></i>
            </button>
          }

          <!-- Close button -->
          <button
            (click)="onClose()"
            class="absolute top-4 right-4 w-12 h-12 bg-black/50 hover:bg-primary hover:text-white border border-white/10 backdrop-blur-md rounded-full flex items-center justify-center text-white transition-all hover:scale-110"
          >
            <i class="fa-solid fa-times"></i>
          </button>

          <!-- Image indicator -->
          @if (galleryImages.length > 1) {
            <div
              class="absolute -bottom-12 left-1/2 -translate-x-1/2 px-4 py-2 bg-black/50 border border-white/10 backdrop-blur-md rounded-full text-white text-sm font-mono tracking-widest"
            >
              {{ selectedImageIndex + 1 }} / {{ galleryImages.length }}
            </div>
          }
        </div>
      </div>
    }
  `,
})
export class ImageModalComponent {
  @Input() isOpen: boolean = false;
  @Input() galleryImages: string[] = [];
  @Input() selectedImageIndex: number = 0;

  @Output() close = new EventEmitter<void>();
  @Output() previousImage = new EventEmitter<void>();
  @Output() nextImage = new EventEmitter<void>();

  onClose() {
    this.close.emit();
  }

  onPreviousImage() {
    this.previousImage.emit();
  }

  onNextImage() {
    this.nextImage.emit();
  }
}
